import React from "react";

function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  options?: { value: string; label: string }[];
  variant: string;
  state?: string;
  disabled?: boolean;
  min?: number;
  type?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputEnd?: React.ReactNode;
  step?: string;
  autoFocus?: boolean;
}) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    state,
    disabled,
    value,
    onChange,
    inputEnd,
    step,
    autoFocus,
    min,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className="mb-1.5 block text-xs font-medium text-gray-600 dark:text-white/70"
      >
        {label}
      </label>
      <div className="relative">
        <input
          disabled={disabled}
          type={type}
          id={id}
          min={min}
          autoFocus={autoFocus}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          step={step}
          className={`flex h-10 w-full rounded-lg border bg-white px-3 text-sm outline-none transition-colors placeholder:text-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 ${
            disabled
              ? "cursor-not-allowed border-transparent bg-gray-50 text-gray-500 dark:bg-white/5"
              : state === "error"
              ? "border-red-300 text-red-600 focus:border-red-500 focus:ring-red-500"
              : state === "success"
              ? "border-green-300 text-green-600 focus:border-green-500 focus:ring-green-500"
              : "border-gray-200 text-gray-900 dark:border-white/10 dark:bg-white/5 dark:text-white"
          }`}
        />
        {inputEnd && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {inputEnd}
          </div>
        )}
      </div>
    </div>
  );
}

function ResizableInputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  footerText?: string;
}) {
  const { label, id, extra, placeholder, state, disabled } = props;

  return (
    <div className={extra}>
      <label
        htmlFor={id}
        className="mb-1.5 block text-xs font-medium text-gray-600 dark:text-white/70"
      >
        {label}
      </label>
      <div className="relative">
        <textarea
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          value={props.value}
          onChange={props.onChange}
          className={`min-h-20 w-full resize-y rounded-lg border bg-white px-3 py-2.5 text-sm outline-none transition-colors placeholder:text-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 ${
            disabled
              ? "cursor-not-allowed border-transparent bg-gray-50 text-gray-500 dark:bg-white/5"
              : state === "error"
              ? "border-red-300 text-red-600"
              : state === "success"
              ? "border-green-300 text-green-600"
              : "border-gray-200 text-gray-900 dark:border-white/10 dark:bg-white/5 dark:text-white"
          }`}
        />
        {props.footerText && (
          <div className="absolute bottom-2.5 right-3 text-xs text-gray-400">
            {props.footerText}
          </div>
        )}
      </div>
    </div>
  );
}

export { InputField, ResizableInputField };
